;(function() {
  'use strict'

  service.$inject = ["AUTH_EVENTS", "$q", "$rootScope", "glDialog", "userService", "elementFactory", "userElementsResource"];
  angular.module('core.services').factory('communityService', service)

  /* @ngInject */
  function service(
    AUTH_EVENTS,
    $q,
    $rootScope,
    glDialog,
    userService,
    elementFactory,
    userElementsResource
  ) {
    var Events = {
      JOINED: 'community:joined',
      LEFT: 'community:left',
    }

    var States = {
      IDLE: 'idle',
      LOADING: 'loading',
      READY: 'ready',
      NONE: 'none',
      ERROR: 'error',
    }

    var communities = {
      list: [],
      refresh: refresh,
      state: States.IDLE,
      error: null,
    }

    $rootScope.$on(AUTH_EVENTS.loginSuccess, refresh)
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, reset)

    return {
      getAll: getAll,
      get: get,
      confirmLeave: confirmLeave,
      Events: Events,
    }

    function getAll() {
      communities.promise = refresh(true)
      return communities
    }

    function refresh(isGetter) {
      return $q(function(resolve, reject) {
        isGetter = isGetter === true

        if (!userService.loggedIn()) {
          return reject({ status: 401 })
        }

        if (
          isGetter &&
          (communities.state === States.READY ||
            communities.state === States.NONE)
        ) {
          return resolve(communities.list)
        }

        communities.state = States.LOADING

        userElementsResource
          .get()
          .success(function(res, response) {
            elementFactory.transform(response)
            angular.copy(response, communities.list)
            // communities.list.push.apply(communities.list, loadingCache);
            resolve(communities.list)
            communities.state =
              communities.list.length > 0 ? States.READY : States.NONE
          })
          .error(function(response, status) {
            communities.error = {
              response: response,
              status: status,
            }
            reject(communities.error)
            communities.state = States.ERROR
          })
      })
    }

    function confirmLeave() {
      return glDialog.show({
        templateUrl: 'confirm-dialog.template.html',
        controller: angular.noop,
        locals: {
          title: 'Leave Crowd',
          message: 'Are you sure you want to leave this crowd?',
          closeText: 'Leave',
          cancelText: 'Cancel',
        },
      })
    }

    function join(elementId) {
      return $q(function(resolve, reject) {
        if (!userService.loggedIn()) {
          return reject()
        }
        userElementsResource
          .create({
            elementId: elementId,
          })
          .success(function() {
            resolve()
            $rootScope.$broadcast(Events.JOINED)
          })
          .error(function() {
            reject()
          })
      })
    }

    function leave(elementId) {
      return $q(function(resolve, reject) {
        if (!userService.loggedIn()) {
          return reject()
        }
        userElementsResource
          .delete({
            id: elementId,
          })
          .success(function() {
            resolve()
            $rootScope.$broadcast(Events.LEFT)
          })
          .error(function() {
            reject()
          })
      })
    }

    function reset() {
      angular.copy([], communities.list)
      communities.state = States.IDLE
    }

    function get(elementId) {
      var community = {
        isJoined: isJoined,
        join: joinCommunity,
        leave: leaveCommunity,
      }
      return community

      function joinCommunity() {
        return join(elementId).then(refresh)
      }

      function leaveCommunity() {
        return leave(elementId).then(refresh)
      }

      function isJoined() {
        return !!_.find(communities.list, { id: elementId })
      }
    }
  }
})()
